module.exports = {
  LONG_POLLING: 'long-polling',
  WEBSOCKET: 'websocket'
}